export const COOKIE_PHONE = 'login-phone'
export const COOKIE_PHONE_ID = 'login-phone-id'
export const COOKIE_POST_LOGIN_REDIRECT = 'post_login_redirect'
